import { Injectable, ViewChild } from '@angular/core';
declare var jQuery: any;

@Injectable()
export class ControlsService {
    constructor() { }

    initializeControls(route: string){
        console.log("sample");
      jQuery.AdminBSB.browser.activate();
      jQuery.AdminBSB.leftSideBar.activate();
      // jQuery.AdminBSB.rightSideBar.activate();
      // jQuery.AdminBSB.navbar.activate();
      jQuery.AdminBSB.dropdownMenu.activate();
      jQuery.AdminBSB.input.activate();
      // jQuery.AdminBSB.select.activate();
      jQuery.AdminBSB.search.activate();
      // jQuery("ml-menu > li").removeClass('active');
      // jQuery(route).addClass('active');
      setTimeout(function () { jQuery('.page-loader-wrapper').fadeOut(); }, 50);

      jQuery('.mce-notification-inner').css("display", "none");
      jQuery('#main-body').addClass('theme-grey theme-egzo');
    }

    showLoader(){
        jQuery('.loader-data').show();
    }

    hideLoader(){
        jQuery('.loader-data').hide();
    }
  }



// WEBPACK FOOTER //
// ./src/app/shared/controls.service.ts